var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("wine-list-item", {
    staticClass: "chi_wine_list_item--container",
    attrs: {
      item: _vm.item,
      "pricing-types": _vm.pricingTypes,
      layout: _vm.priceLayout,
      "is-grouped-by-price": _vm.isGroupedByPrice,
      "show-bin": _vm.showBin,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }